import React, { useEffect } from "react";
import { Helmet } from 'react-helmet-async';
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Container, Row, Col } from "react-bootstrap";
import Image3 from "../assets/images/company/image-3.jpg";

function DeliveryAndShipment({ setPageTitle }) {

    useEffect(() => {
        setPageTitle("Delivery and Shipment - Bait Al Anaqah");
    }, [setPageTitle]);

    return (
        <>
            <Helmet>
                <meta name="keywords" content="Bait Al Anaqah, Bespoke, Uniforms, Alteration, Custom, Dubai" />
                <meta name="title" property="og:title" content={setPageTitle}></meta>
                <meta property="og:type" content="website" />
                <meta name="description" property="og:description" content="Experience the elegance of Bait Al Anaqah, where every creation tells a story and reflects your unique identity while honoring your values." />
                <meta name="image" property="og:image" content={Image3} />
            </Helmet>
            <Navbar />
            <Container className="py-5">
                <Row>
                    <Col lg={8} className="mx-auto">
                        <h1 className="mb-5">Delivery & Shipment</h1>
                        <h5 className="fw-bold">
                        WHEN CAN YOU EXPECT YOUR BESPOKE ORDER?
                        </h5>
                        <h5 className="fw-bold">
                        Regular Delivery
                        </h5>
                        <p>
                        At Bait Al Anaqah, we dedicate ourselves to crafting every bespoke order with meticulous attention to detail. Once an order is placed, it typically takes 7-10 business days to create your bespoke clothing. After that, shipping will take an additional 3-5 business days. During peak seasons like Eid and other cultural festivals, high demand may result in delays.
                        </p>
                        <h5 className="fw-bold">
                        Express Delivery
                        </h5>
                        <p>
                        If you need your bespoke clothing sooner, we offer an Express Delivery service for an additional fee. This service fast-tracks your order, creating your bespoke garment in 2-3 business days, with shipping through Aramex. Please rest assured that this expedited service will not compromise the quality of your garment.
                        </p>
                        <p>
                        Bait Al Anaqah offers FREE express delivery worldwide (excluding regions where UAE law prohibits delivery). Please note that applicable duties and taxes are the responsibility of the customer.
                        </p>
                        <h5 className="fw-bold">
                        Shipping Essentials
                        </h5>
                        <p>
                        We offer worldwide shipping, excluding regions where UAE law restricts delivery. Orders are shipped from Monday to Friday between 9:00 AM and 6:00 PM (UAE Standard Time). Once your order has been shipped, we cannot redirect it. Bait Al Anaqah is not responsible for any delays in customs clearance. Any duties and customs charges incurred will be your responsibility.
                        </p>
                        <h5 className="fw-bold">
                        Track Your Order
                        </h5>
                        <p>
                        Once your order is dispatched, you will receive an email confirmation with a tracking number. Please ensure that you provide an active email address and mobile number when placing your order to receive timely updates on your shipment’s progress.
                        </p>
                        <h5 className="fw-bold">
                        In case of Failed Delivery
                        </h5>
                        <p>
                        For security reasons, we cannot modify the delivery address once an order is placed. If you miss a delivery attempt, the courier will leave a note with instructions on how to arrange a re-delivery or where to pick up your package.
                        </p>
                        <p>
                        If a delivery attempt fails and the shipment is returned to Bait Al Anaqah, you will need to place a new order to receive your items.
Please ensure you provide accurate address details when placing your order to avoid any delays or misdeliveries. Bait Al Anaqah is not responsible for deliveries to incorrect addresses.
                        </p>
                        <h5 className="fw-bold">
                        HAVE QUESTIONS? CONTACT US
                        </h5>
                        <p>
                        For any additional queries, please email our Customer Care Team at info@baitalanaqah.com (available from Saturday to Thursday, 9:00 AM to 4:00 PM UAE Standard Time).
                        </p>
                    </Col>
                </Row>
            </Container>
            <Footer />
        </>
    );
}

export default DeliveryAndShipment;
